<template>
    <v-container class="max-height my-5">
        <v-row>
            <h1 class="text-left">Trips Summary</h1>
        </v-row>

        <v-row>
            <v-col v-if="user.type === 'admin'" cols="12" md="3" sm="6">
                <company-select v-model="formData['company']" :items="companiesList" density="compact" label="Select Company"
                          @update:model-value="()=>{resetForm();fetchAssetList();fetchDriversList();}"/>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-select v-model="formData['assets']" :items="assetsList" clearable density="compact"
                          item-title="label" item-value="id" label="Select Asset(s)" multiple
                          @update:model-value="fetchTripReport()"/>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-select v-model="formData['driver']" :items="driversList" clearable
                          density="compact" :item-title="d => `${d.first_name || ''} ${d.last_name || ''}`.trim()" item-value="id" label="Select Driver"
                          @update:model-value="fetchTripReport()"/>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-select v-model="formData['period']"
                          :items="[{title:'Daily','value':'daily'},{title:'Monthly','value':'monthly'},{title:'Yearly','value':'yearly'}]"
                          density="compact" label="Select Days"
                          @update:model-value="fetchTripReport()"/>
            </v-col>
        </v-row>

        <v-row v-if="tripStats">
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>No. of Trips</th>
                        <th>Duration</th>
                        <th>Distance</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="tripStat in tripStats" v-if="tripStats.length" class="text-left">
                        <td>{{ formattedDate(tripStat.date) }}</td>
                        <td>{{ tripStat.trips_count }}</td>
                        <td>{{ Math.round(tripStat.duration / 60) }} minutes</td>
                        <td>{{ strOperations().unitifyDistance(tripStat.distance, 'distance', 'km') }}</td>
                    </tr>
                    <tr v-else>
                        <td v-if="!tripStats" class="text-center" colspan="3">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="3">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
        <v-row v-if="totalPages > 1" justify="center">
            <v-col>
                <v-pagination v-model="formData['page']" :length="totalPages" class="my-4" density="compact"
                              @update:model-value="fetchTripReport"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {strOperations} from "@/composables/globals";
import CompanySelect from "@/components/globals/company-select.vue";

const {user} = useAuthStore();
const totalPages = ref(1);
const tripStats = ref(null);
const driversList = ref([]);
const companiesList = ref([]);
const assetsList = ref([]);
const {showSnackbar} = useSnackbarStore();
const formData = reactive({
    page: 1,
    driver: null,
    assets: null,
    period: 'daily',
    company: ref(user.type !== 'admin' ? user.company.id : null),
})

onMounted(() => {
    if (user.type === 'admin') {
        fetchCompaniesList();
    } else {
        fetchAssetList();
        fetchTripReport();
        fetchDriversList();
    }
})

const formattedDate = (date) => {
    switch (formData['period']) {
        case 'daily':
            return new Date(date).toLocaleDateString()
        case 'monthly':
            return `${new Date(date).getMonth() + 1} / ${new Date(date).getFullYear()}`
        case 'yearly':
            return new Date(date).getFullYear()
    }
}
const resetForm = () => {
    formData['page'] = 1;
    formData['assets'] = null;
    formData['driver'] = null;
    totalPages.value = 1;
    fetchTripReport();
}
const fetchCompaniesList = () => {
    send('get', `companies/list`)
        .then((response) => {
            companiesList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Companies List could not be loaded', 'error')
        })
}
const fetchAssetList = () => {
    return send('get', `assets/list`, {company: formData['company']})
        .then((response) => {
            assetsList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Assets List could not be loaded', 'error')
        })
}
const fetchDriversList = () => {
    send('get', `companies/drivers?list=true`, {company: formData['company']})
        .then((response) => {
            driversList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Drivers List could not be loaded', 'error')
        })
}
const fetchTripReport = () => {
    send('get', `reports/trips-summary`, formData)
        .then((response) => {
            tripStats.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            formData['page'] = response.data.data.current_page;
        })
        .catch((error) => {
            showSnackbar('Trips summary could not be loaded', 'error')
        })
}
</script>
